import React from "react";
import { Moon, Sun } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useTheme } from "@/context/ThemeContext";

export function ThemeToggle({ className = "" }) {
  const { resolved, toggle } = useTheme();
  const isDark = resolved === "dark";

  return (
    <Button
      variant="outline"
      size="icon"
      onClick={toggle}
      className={`relative overflow-hidden rounded-full transition-colors duration-200 ${className}`}
      aria-label="Toggle theme"
      data-testid="theme-toggle-button"
    >
      <Sun
        className={`h-[1.1rem] w-[1.1rem] transition-transform duration-300 ${
          isDark ? "-rotate-90 scale-0" : "rotate-0 scale-100"
        }`}
      />
      <Moon
        className={`absolute h-[1.1rem] w-[1.1rem] transition-transform duration-300 ${
          isDark ? "rotate-0 scale-100" : "rotate-90 scale-0"
        }`}
      />
    </Button>
  );
}
